import * as React from 'react'
import { Helmet } from 'react-helmet'
import { withRouter } from 'react-router'

// components
import CardSlider from '../../../../components/home/CardSlider/CardSlider'
import CardListModal from '../../../../components/ui/CardListModal/CardListModal'
import ArticleCard from '../../../../components/ui/ArticleCard/ArticleCard'
import DashboardLayout from '../../../../components/ui/DashboardLayout/DashboardLayout'
import Section from '../../../../components/ui/Section/Section'
import Icon from '../../../../components/ui/Icon/Icon'
import MerchantsListModal from '../../../../components/home/MerchantsListModal/MerchantsListModal'
import StoreModal from '../../../../components/home/StoreModal/StoreModal'
import FeaturedCard from '../../../../components/home/FeaturedCard/FeaturedCard'
import EventsCard from '../../../../components/home/EventsCard/EventsCard'
import PromoCard from '../../../../components/home/PromoCard/PromoCard'
import MarketingContentModal from '../../../../components/home/MarketingContentModal/MarketingContentModal'
import {
  ButtonNav,
  ButtonNavWrapper,
  StyledBannerImage,
} from './MainView.style'

// assets
import ResponsiveAdsContainer from '../../../../components/ads/ResponsiveAdsContainer/ResponsiveAdsContainer'

// ads
import DesktopLeaderboard from '../../../../components/ads/DesktopLeaderboard/DesktopLeaderboard'
import MobileRectangle from '../../../../components/ads/MobileRectangle/MobileRectangle'
// import HeaderPageLeaderboard from '../../../../components/ads/HeaderPageLeaderboard/HeaderPageLeaderboard'
// import HeaderPageRectangle from '../../../../components/ads/HeaderPageRectangle/HeaderPageRectangle'

// data
import filterString from '../../../../services/data/filterString'
import getMarketingContentLabel from '../../../../services/data/getMarketingContentLabel'
import viewTypeBaseUrl from '../../../../services/data/viewTypeBaseUrl'
import { DASHBOARD } from '../../../../services/data/marketingContentAppearance'
import {
  PROMO_EVENTS_TOPPICKS,
  PROMO_EVENTS_TOPPICKS_EMPTY,
  PROMO_EVENTS_EVENTS,
  PROMO_EVENTS_PROMOS,
  DASHBOARD_PROMOS_EMPTY,
} from '../../../../services/data/errorNames.json'

//  analytics
import {
  setGAPageView,
  setGAEvent,
} from '../../../../services/analytics/google-analytics'

// controllers
import { doGetPromosEventsSections } from '../../../../controllers/MarketingContent'
import {
  doGetAllMalls,
  // , doGetAllCMSMalls
} from '../../../../controllers/Malls'
import { doGetDashboardHeroBannerPromosAndEvents } from '../../../../controllers/Dashboard'
import { doGetDashboardStore as doGetPromosEventsStore } from '../../../../controllers/Explore'
import sanitizeHTML from '../../../../services/sanitizeHTML'

import { BannerCaption } from './MainView.style'

const sectionDescription = doGetPromosEventsSections()

class MainView extends React.Component {
  constructor(props) {
    super(props)

    this.featuredSlider = React.createRef()
    this.promosSlider = React.createRef()
    this.eventsSlider = React.createRef()
    this.merchantsSlider = React.createRef()

    const {
      setHeroBannerPromosAndEvents,
      setMalls,
      // , setCMSMalls
    } = this.props

    this.state = {
      cardListModalOption: {},
      relatedArticles: [],
    }

    doGetDashboardHeroBannerPromosAndEvents({ setHeroBannerPromosAndEvents })

    doGetAllMalls({ setMalls })

    // doGetAllCMSMalls({
    //   setCMSMalls,
    //   onError: error => {
    //     let { errors: errorsObj } = this.state

    //     this.setState({
    //       errors: {
    //         ...errorsObj,
    //         cmsMalls: error.message
    //       }
    //     })
    //   },
    // })

    this.getPromosEventsFeatured()

    this.getPromosEventsEvents()

    this.getPromosEventsPromos()
  }

  componentWillMount() {
    const { waitRenderServer } = this.props
    waitRenderServer(true)

    this.displayModal()
  }

  componentDidMount() {
    const { location } = this.props

    setGAPageView(location.pathname)
  }

  componentDidUpdate(prevProps) {
    const { match, waitRenderServer } = this.props
    const { viewType, viewId } = match.params
    const {
      viewType: prevViewType,
      viewId: prevViewId,
    } = prevProps.match.params

    if (viewType !== prevViewType || viewId !== prevViewId) {
      waitRenderServer(true)
      this.displayModal()
    }
  }

  getPromosEventsFeatured = () => {
    const {
      setFeatured,
      setError,
      removeError,
      errorList,
      doGetFeaturedMarketingContent,
    } = this.props

    const pageLoadStart = Date.now()

    if (errorList.length) removeError(PROMO_EVENTS_TOPPICKS)

    doGetFeaturedMarketingContent({
      setFeatured,
      onSuccess: data => {
        if (!data.length) {
          setError({
            name: PROMO_EVENTS_TOPPICKS_EMPTY,
          })
        }
        setGAEvent(
          'page',
          'loading_duration',
          'promos_and_events_top_picks',
          Date.now() - pageLoadStart,
        )
      },
      onError: error => {
        setError({
          name: PROMO_EVENTS_TOPPICKS,
          error: error.message,
        })
      },
    })(10, DASHBOARD)
  }

  getPromosEventsEvents = () => {
    const {
      setEvents,
      setError,
      removeError,
      errorList,
      doGetWhatsOn,
    } = this.props

    const pageLoadStart = Date.now()

    if (errorList.length) {
      removeError(PROMO_EVENTS_EVENTS)
    }

    doGetWhatsOn({
      setWhatsOn: setEvents,
      onSuccess: () => {
        setGAEvent(
          'page',
          'loading_duration',
          'promos_and_events_whats_on',
          Date.now() - pageLoadStart,
        )
      },
      onError: error => {
        setError({
          name: PROMO_EVENTS_EVENTS,
          error: error.message,
        })
      },
    })(9)
  }

  getPromosEventsPromos = () => {
    const {
      setPromos,
      setError,
      removeError,
      errorList,
      doGetBestDeals,
    } = this.props

    const pageLoadStart = Date.now()

    if (errorList.length) {
      removeError(PROMO_EVENTS_PROMOS)
    }
    doGetBestDeals({
      setBestDeals: data => setPromos(data.reverse()),
      onSuccess: data => {
        if (!data.length) {
          setError({
            name: DASHBOARD_PROMOS_EMPTY,
          })
        }
        setGAEvent(
          'page',
          'loading_duration',
          'promos_and_events_best_deals',
          Date.now() - pageLoadStart,
        )
      },
      onError: error => {
        setError({
          name: PROMO_EVENTS_PROMOS,
          error: error.name,
        })
      },
    })(9)
  }

  featuredSliderNext = () => {
    this.featuredSlider.current.slickNext()
  }

  featuredSliderPrev = () => {
    this.featuredSlider.current.slickPrev()
  }

  promosSliderNext = () => {
    this.promosSlider.current.slickNext()
  }

  promosSliderPrev = () => {
    this.promosSlider.current.slickPrev()
  }

  eventsSliderNext = () => {
    this.eventsSlider.current.slickNext()
  }

  eventsSliderPrev = () => {
    this.eventsSlider.current.slickPrev()
  }

  merchantsSliderNext = () => {
    this.merchantsSlider.current.slickNext()
  }

  merchantsSliderPrev = () => {
    this.merchantsSlider.current.slickPrev()
  }

  moviesSliderNext = () => {
    this.moviesSlider.current.slickNext()
  }

  moviesSliderPrev = () => {
    this.moviesSlider.current.slickPrev()
  }

  handleClose = () => {
    const {
      push,
      baseUrl,
      setMarketingContentModalData,
      setMarketingContentModalStatus,
      setCurrentMallInModal,
      setOurMallModalStatus,
      setCardListModalStatus,
    } = this.props

    if (push) {
      push(baseUrl)
      setMarketingContentModalData({})
      setMarketingContentModalStatus(null)
      setCurrentMallInModal(null)
      setOurMallModalStatus(null)
      setCardListModalStatus(null)
    }
  }

  setRelatedArticles = relatedArticles => {
    this.setState({ relatedArticles })
  }

  displayModal = async () => {
    const {
      match,
      // promos,
      events,
      merchants,
      setMarketingContentModalData,
      setMarketingContentModalStatus,
      setStoreModalData,
      setCurrentMallInModal,
      setOurMallModalStatus,
      setCardListModalData,
      setCardListModalStatus,
      renderServer,
      doGetMarketingContent,
      doGetRelatedArticles,
      doGetWhatsOn,
      doGetBestDeals,
      doGetFeaturedMarketingContent,
      // server,
    } = this.props
    const { viewType, viewId } = match.params

    if (viewType === undefined || viewId === undefined) {
      renderServer()
    }

    if (
      (viewType === 'whats-on' ||
        viewType === 'best-deals' ||
        viewType === 'announcements' ||
        viewType === 'ads' ||
        viewType === 'others') &&
      viewId
    ) {
      const contentId = viewId.split('-').pop()

      setCardListModalStatus(null)
      const filteredData = events.filter(({ id }) => `${id}` === `${contentId}`)
      let contentModalData = filteredData[0] || null

      setMarketingContentModalStatus(1)

      doGetRelatedArticles({ setRelatedArticles: this.setRelatedArticles })(
        contentId,
      )
      if (!contentModalData) {
        await doGetMarketingContent({
          setMarketingContent: setMarketingContentModalData,
          onSuccess: () => {
            setMarketingContentModalStatus(0)
            renderServer()
          },
          onError: () => setMarketingContentModalStatus(4),
        })(contentId)
      } else {
        setMarketingContentModalData({
          ...sanitizeHTML(contentModalData),
          body: contentModalData.body.replace(/<a href="(.+?)"/g, (_, url) => {
            const isAbsolute =
              url.startsWith('http://') || url.startsWith('https://')
            const theUrl = sanitizeHTML(isAbsolute ? url : `http://${url}`)
            return `<a href="${theUrl}" target="_blank"`
          }),
        })
        setMarketingContentModalStatus(0)
      }
    } else if (viewType === 'merchant' && viewId) {
      const filteredData = merchants.filter(({ id }) => `${id}` === `${viewId}`)
      const storeModalData = filteredData[0] || {}

      doGetPromosEventsStore({ setStoreModalData, storeId: storeModalData.id })
    } else if (viewType === 'whats-on') {
      doGetWhatsOn({
        setWhatsOn: setCardListModalData,
        onSuccess: () => setCardListModalStatus(0),
        onError: () => {
          setCardListModalData([])
          setCardListModalStatus(4)
        },
      })()

      this.setState({
        cardListModalOption: sectionDescription.event,
      })
    } else if (viewType === 'best-deals') {
      doGetBestDeals({
        setBestDeals: setCardListModalData,
        onSuccess: () => setCardListModalStatus(0),
        onError: () => {
          setCardListModalData([])
          setCardListModalStatus(4)
        },
      })()

      this.setState({
        cardListModalOption: sectionDescription.promo,
      })
    } else if (viewType === 'top-picks') {
      doGetFeaturedMarketingContent({
        setFeatured: setCardListModalData,
        onSuccess: () => setCardListModalStatus(0),
        onError: () => {
          setCardListModalData([])
          setCardListModalStatus(4)
        },
      })('', DASHBOARD)

      this.setState({
        cardListModalOption: sectionDescription.featured,
      })
    } else {
      setMarketingContentModalData({})
      setMarketingContentModalStatus(null)
      setCurrentMallInModal(null)
      setOurMallModalStatus(null)
      setCardListModalStatus(null)

      setGAEvent('page', 'page_visit', 'promos_and_events')
    }
    // renderServer()
  }

  render() {
    const {
      featured,
      promos,
      events,
      malls,
      baseUrl,
      cardListModalData,
      showCardListModal,
      cardListModalStatus,
      showMarketingContentModal,
      marketingContentModalData,
      marketingContentModalStatus,
      showMerchantsListModal,
      merchantsListModalData,
      setMerchantsListModalData,
      showStoreModal,
      storeModalData,
      setStoreModalData,
      currentMallInModal,
      showOurMallModal,
      heroBannerPromosAndEvents,
      ...theProps
    } = this.props

    const { cardListModalOption, relatedArticles } = this.state

    const { match, push, errorList } = this.props

    const sanitizedModalData = {
      ...marketingContentModalData,
      body: sanitizeHTML(marketingContentModalData.body),
    }
    const heroBannerData = heroBannerPromosAndEvents

    return (
      <DashboardLayout
        variant="promos-events"
        heroBannerData={heroBannerData}
        heroBannerLeft={
          heroBannerPromosAndEvents && !heroBannerPromosAndEvents.layout
        }
        {...(!!heroBannerData?.desktopCaption?.showCaption && {
          heroBannerTitle: (
            <BannerCaption
              src={heroBannerData && heroBannerData.desktopCaption.url}
            />
          ),
        })}
        heroLink="/explore"
        featuredSection={
          !errorList.find(
            error => error.name === PROMO_EVENTS_TOPPICKS_EMPTY,
          ) && (
            <>
              <CardSlider
                dataSource={featured}
                loadingComponent={() => (
                  <FeaturedCard
                    loading
                    error={errorList.find(
                      error =>
                        error.name === PROMO_EVENTS_TOPPICKS ||
                        error.name === PROMO_EVENTS_TOPPICKS_EMPTY,
                    )}
                    onRetry={this.getPromosEventsFeatured}
                  />
                )}
                renderItem={(item, index) => {
                  const newIndex = index + 1
                  const newId = featured.length === newIndex ? 0 : newIndex

                  return (
                    <FeaturedCard
                      key={item.itemId}
                      id={newId}
                      featuredImgUrl={item.logoUrl}
                      bannerImgUrl={item.imageUrl}
                      schedule={item.subtitle}
                      title={item.title}
                      body={filterString(item.description)}
                      // label={item.customLabel}
                      label={getMarketingContentLabel(item).name}
                      // link={`${viewTypeBaseUrl(item.type)}/${
                      //   item.type === 0 || item.type === 1
                      //     ? item.slugName
                      //     : item.itemId
                      // }`}
                      link={sanitizeHTML(
                        `${viewTypeBaseUrl(item.type)}/${item.slugName}`,
                      )}
                      onClick={() =>
                        setGAEvent(
                          'item_clicks',
                          'view_promos_and_events_top_picks_item',
                          item.title,
                        )
                      }
                    />
                  )
                }}
                onViewAllClick={() => push(`${baseUrl}/top-picks`)}
                ref={this.featuredSlider}
                featured
              />

              <>
                <ButtonNavWrapper left>
                  <ButtonNav onClick={this.featuredSliderPrev}>
                    <Icon name="slide-left" />
                  </ButtonNav>
                </ButtonNavWrapper>

                <ButtonNavWrapper>
                  <ButtonNav onClick={this.featuredSliderNext} right>
                    <Icon name="slide-right" />
                  </ButtonNav>
                </ButtonNavWrapper>
              </>
            </>
          )
        }
        altHeaderAd
        altFooterAd
        {...theProps}
      >
        {events && events.length > 0 && (
          <>
            <Section
              sectionTitle={sectionDescription.event.title}
              sectionText={sectionDescription.event.description}
              sectionContentType="small"
              sliderNext={this.eventsSliderNext}
              sliderPrev={this.eventsSliderPrev}
              to={`${baseUrl}/whats-on`}
              lightOnSmall
            >
              <CardSlider
                ref={this.eventsSlider}
                dataSource={events}
                loadingComponent={() => (
                  <EventsCard
                    loading
                    error={errorList.find(
                      error => error.name === PROMO_EVENTS_EVENTS,
                    )}
                    onRetry={this.getPromosEventsEvents}
                  />
                )}
                renderItem={(item, index) => (
                  <EventsCard
                    key={item.itemId}
                    id={index}
                    logoImageUrl={item.logoUrl}
                    subtitle={item.subtitle}
                    title={item.title}
                    link={sanitizeHTML(
                      `${viewTypeBaseUrl(item.type)}/${item.slugName}`,
                    )}
                    onClick={() =>
                      setGAEvent(
                        'item_clicks',
                        'view_promos_and_events_whats_on_item',
                        item.title,
                      )
                    }
                    malls={item.malls}
                  />
                )}
              />
            </Section>
            <ResponsiveAdsContainer
              desktop={<DesktopLeaderboard id="div-ad-innity-91042/5" />}
              mobile={<MobileRectangle id="div-ad-innity-91046/5" />}
            />
          </>
        )}
        {!errorList.find(error => error.name === DASHBOARD_PROMOS_EMPTY) && (
          <>
            <Section
              contentDirection={events.length > 0 ? 'rtl' : 'ltr'}
              reverse={events.length > 0}
              sectionTitle={sectionDescription.promo.title}
              sectionText={sectionDescription.promo.description}
              sliderNext={this.promosSliderNext}
              sliderPrev={this.promosSliderPrev}
              to={`${baseUrl}/best-deals`}
              // contentDirection="rtl"
              // reverse
              tertiary
            >
              <CardSlider
                key={promos.length - 1}
                ref={this.promosSlider}
                dataSource={promos}
                loadingComponent={() => (
                  <PromoCard
                    loading
                    error={errorList.find(
                      error => error.name === PROMO_EVENTS_PROMOS,
                    )}
                    onRetry={this.getPromosEventsPromos}
                  />
                )}
                initialSlide={promos.length ? promos.length - 1 : 2}
                renderItem={(item, index) => (
                  <PromoCard
                    key={item.itemId}
                    id={promos.length - (index + 1)}
                    logoImageUrl={item.logoUrl}
                    subtitle={item.subtitle}
                    title={item.title}
                    link={sanitizeHTML(
                      `${viewTypeBaseUrl(item.type)}/${item.slugName}`,
                    )}
                    onClick={() =>
                      setGAEvent(
                        'item_clicks',
                        'view_promos_and_events_best_deals_item',
                        item.title,
                      )
                    }
                    malls={item.malls}
                  />
                )}
              />
            </Section>
          </>
        )}
        <ResponsiveAdsContainer
          desktop={<DesktopLeaderboard id="div-ad-innity-91042/11" />}
          mobile={<MobileRectangle id="div-ad-innity-91046/11" />}
        />
        <MerchantsListModal
          data={merchantsListModalData}
          show={showMerchantsListModal}
          setMerchantsListModalData={setMerchantsListModalData}
          showStoreModal={showStoreModal}
          setStoreModalData={setStoreModalData}
        />
        <StoreModal
          malls={malls}
          show={showStoreModal}
          data={storeModalData}
          setStoreModalData={setStoreModalData}
          merchantsListModalData={merchantsListModalData}
          onClose={() => setStoreModalData(null)}
        />
        <MarketingContentModal
          malls={malls}
          show={showMarketingContentModal}
          data={{ ...sanitizedModalData, relatedArticles }}
          shareUrl={`${process.env.REACT_APP_BASE_URL}${encodeURI(match.url)}`}
          onClose={this.handleClose}
          setMerchantsListModalData={setMerchantsListModalData}
          showMerchantsListModal={showMerchantsListModal}
          loading={marketingContentModalStatus}
        />
        <CardListModal
          show={showCardListModal}
          onClose={this.handleClose}
          loading={cardListModalStatus}
          title={cardListModalOption.title}
          description={cardListModalOption.description}
          source={cardListModalData}
          render={item => {
            const { title, type, subtitle, imageUrl, logoUrl } = item
            const linkBaseUrl = viewTypeBaseUrl(type)

            return (
              <ArticleCard
                key={`${type}-${item.itemId}`}
                imageUrl={imageUrl}
                logoUrl={logoUrl}
                title={title}
                schedule={subtitle}
                // link={`${linkBaseUrl}/${
                //   type === 0 || type === 1 ? item.slugName : item.itemId
                // }`}
                link={`${linkBaseUrl}/${item.slugName}`}
              />
            )
          }}
        />
        {showMarketingContentModal && marketingContentModalData && (
          <Helmet defaultTitle={filterString(marketingContentModalData.title)}>
            <meta
              name="description"
              content={filterString(marketingContentModalData.body)}
            />
            <link
              rel="canonical"
              href={filterString(marketingContentModalData.pageUrl)}
            />
            <meta
              property="og:url"
              content={filterString(marketingContentModalData.pageUrl)}
            />
            <meta
              property="og:title"
              content={filterString(marketingContentModalData.title)}
            />
            <meta
              property="og:description"
              content={filterString(marketingContentModalData.body)}
            />
            <meta
              property="og:image"
              content={
                marketingContentModalData.bannerImage
                  ? filterString(marketingContentModalData.bannerImage.url)
                  : ''
              }
            />
            <meta
              property="og:image:secure_url"
              content={
                marketingContentModalData.bannerImage
                  ? filterString(marketingContentModalData.bannerImage.url)
                  : ''
              }
            />
            <meta property="og:image:type" content="image/png" />
            <meta property="og:image:width" content="400" />
            <meta property="og:image:height" content="300" />
            <meta property="og:type" content="article" />
          </Helmet>
        )}
        {showOurMallModal && currentMallInModal && (
          <Helmet defaultTitle={currentMallInModal.name}>
            <meta property="og:title" content={currentMallInModal.name} />
            <meta
              property="og:description"
              content={filterString(currentMallInModal.description)}
            />
            <meta
              property="og:image"
              content={
                currentMallInModal.photos
                  ? currentMallInModal.photos[0].url
                  : ''
              }
            />
            <meta property="og:type" content="website" />
          </Helmet>
        )}
      </DashboardLayout>
    )
  }
}

MainView.defaultProps = {
  // TODO: specify default props
}

MainView.propTypes = {
  // TODO: specify prop types
}

export default withRouter(MainView)
